var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ShoppingBag = function ShoppingBag(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3a1 1 0 0 1 .768.36l4.7 5.64H21a1 1 0 0 1 .97 1.242l-1.99 7.963c-.13.737-.462 1.433-.983 1.955-.534.533-1.242.855-2.008.84H7.01c-.766.015-1.474-.307-2.008-.84-.521-.522-.854-1.218-.983-1.955l-1.99-7.962A1 1 0 0 1 3 9h3.532l4.7-5.64A1 1 0 0 1 12 3Zm5.008 8H4.28l1.69 6.758a.994.994 0 0 1 .016.081c.064.393.231.707.43.907.194.194.394.259.558.254h10.05c.164.005.364-.06.558-.254.199-.2.366-.514.43-.907a.942.942 0 0 1 .017-.081L19.72 11h-2.712ZM12 5.562 14.865 9h-5.73L12 5.562ZM11 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ShoppingBag;